<template>
  <ColumnEditModal :value="value" :configName="configName" :columnId="columnId" :editMode="editMode" @input="$emit('input', $event)" v-bind="$attrs">
    <template v-slot:edit-modal-additions="props">
      <v-layout pa-4 wrap>
        <h3> If the Datum Type does not exist for the sample while a new Datum is being created, the Datum should be auto assigned to a Datum Type of: </h3>
        <v-radio-group column :value="getAutoAssignDepthTypeValue(props.columnConfiguration)" @change="callSetColumnMetadata(autoAssignDepthTypeKey, $event)">
          <v-radio class="radio-opts" label="Depth" :value="'0'" />
          <v-radio class="radio-opts" label="Height" :value="'1'" />
          <v-radio class="radio-opts" label="The Datum should not be created and the import should fail." :value="'2'" />
        </v-radio-group>
      </v-layout>
    </template>
  </ColumnEditModal>
</template>
<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  const eddConfiguration = createNamespacedHelpers('plugin/eddConfiguration')
  import ColumnEditModal from './ColumnEditModal'
  import metadataFieldNames from '../../store/metadataFieldNames'

  export default {
    components: {
      ColumnEditModal,
    },
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      configName: {
        type: String,
        required: true,
      },
      columnId: {
        type: String,
        required: true,
      },
      editMode: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        datumCreationDatumType: null,
        autoAssignDepthTypeKey: metadataFieldNames.depthDatumType_autoAssignDepthType,
      }
    },
    methods: {
      ...eddConfiguration.mapActions(['setColumnMetadata']),
      callSetColumnMetadata(metadataFieldName, metadataValue) {
        console.log(metadataValue)
        this.setColumnMetadata({
          configName: this.configName,
          columnId: this.columnId,
          metadataKey: metadataFieldName,
          metadataValue: metadataValue,
        })
      },
      getAutoAssignDepthTypeValue(columnConfiguration) {
        return (columnConfiguration && columnConfiguration.Metadata && columnConfiguration.Metadata[this
          .autoAssignDepthTypeKey]) || false
      },
    },
  }
</script>